import BaseModelAPI from '../BaseModelAPI';

export default class MaritalStatus extends BaseModelAPI {
	static entity = 'maritalstatus';
	static entityName = 'maritalstatus';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.createdBy = '';
			this.updatedBy = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}